import React from "react";
import ButtonTemplate from "../Templates/ButtonTemplate";
import i18n from "../../../../utils/ChrI18n";
import useChrRemoteModal from "../../../../hooks/generic/Form/useChrRemoteModal";
import ManageAlert from "../../../specific/Alerts/ManageAlert";

const Alert = (props) => {
  const actionText = i18n.t("management_report_v2.button.manage_alert");
  const { ChrRemoteModal, remoteModalOptions, remoteModalActions } = useChrRemoteModal({
    dataPath: props.data.dataPath,
    ModalBodyComponent: ManageAlert,
    loaderCount: 1
  })

  return (
    <>
      <ButtonTemplate {...props} onClick={remoteModalActions.showRemoteModal} />
      <ChrRemoteModal
        {...remoteModalOptions}
        header={actionText}
        extraModalBodyProps={{ className: "custom-max-height-550-px overflow-scroll custom-thin-scroll-bar" }}
      />
    </>
  )
}

export default Alert;